import React, { useState } from 'react';
import RadioButton from "./RadioButton";

const RadioGroup = ({list, onRadioSelection}) => {

    const [selectedRadioId, setSelectedRadioKey] = useState('');

    const onSelection = (id) => {
        setSelectedRadioKey(id);
        onRadioSelection(id);
    }
    
    return (
        list && list.length && list.map((item,index) => <RadioButton id={item} isChecked={selectedRadioId === item} label={item} onSelection={onSelection} isLast={index===list.length-1} />)
    )
}

export default RadioGroup;